angular.module("events")

    .controller("GuestVehiclesModalCtrl", ['$scope', '$uibModalInstance', 'event_guest_vehicle', 'event_guest_id', 'Restangular', function ($scope, $uibModalInstance, event_guest_vehicle, event_guest_id, Restangular) {

        // Comprobamos si tiene permiso escritura
        $scope.allowWrite = true;

        if (angular.isUndefined(event_guest_vehicle)) {
            $scope.guestVehicle = { event_guest_id: event_guest_id };

        } else {
            $scope.guestVehicle = event_guest_vehicle;
        }

        $scope.saveGuestVehicle = function () {

            if ($scope.guestVehicle.id) {
                $scope.guestVehicle.put().then(function (result) {
                    $uibModalInstance.close();
                });
            } else {
                Restangular.all('EventsGuestsVehicles').post($scope.guestVehicle).then(function (result) {
                    $uibModalInstance.close(result);
                });
            }
        }

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

    }])